import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from 'react-custom-scrollbars';
import { SpringSystem} from 'rebound';
import './assets/style.scss';
import {faAngleDoubleLeft} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class MenuLeft extends Component {

  constructor(props, ...rest) {
    super(props, ...rest);
    this.handleSpringUpdate = this.handleSpringUpdate.bind(this);

    this.state = {searchText: ''};
  }

  componentDidMount() {
    this.springSystem = new SpringSystem();
    this.spring = this.springSystem.createSpring();
    this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });
  }

  componentWillUnmount() {
    this.springSystem.deregisterSpring(this.spring);
    this.springSystem.removeAllListeners();
    this.springSystem = undefined;
    this.spring.destroy();
    this.spring = undefined;
  }

  getScrollTop() {
    return this.refs.scrollbars.getScrollTop();
  }

  getScrollHeight() {
    return this.refs.scrollbars.getScrollHeight();
  }


  scrollTop(top) {
    const { scrollbars } = this.refs;
    const scrollTop = scrollbars.getScrollTop();
    this.spring.setCurrentValue(scrollTop).setAtRest();
    this.spring.setEndValue(top);
  }

  setCategory(id = null, pid = null) {
    this.props.setCategory({pid, id});
    const items = document.querySelectorAll(`[data-category="${id}"]`);

    if(items.length) {
      this.scrollTop(items[0].offsetTop, items[items.length - 1].offsetTop);
    }

  }

  handleSpringUpdate(spring) {
    const { scrollbars } = this.refs;
    if(!scrollbars) {
      return;
    }
    const val = spring.getCurrentValue();
    scrollbars.scrollTop(val);
  }

  handleOnChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  };

  renderChilds = (items, parentId, currentCategory) => {
    if(items.length) {
      return <ul className="Constructor-Sidebar-Menu-Item-Childs"> {
        items.map((child) => {
          return <li className={child.id === currentCategory ? 'active' : ''} key={child.id} onClick={() => {
            this.setCategory(child.id, parentId);
          }}>
            <span onClick={() => {return false}}>{child.name}</span>
          </li>
        })
      }
      </ul>
    }

    return null;
  };
  renderCategory = (item = {}) => {
    const {pid, id} = this.props.currentCategory || {};
    const {id: categoryId, name, media} = item;

    return <li className={`Constructor-Sidebar-Menu-Item ${item.id === pid ? 'Constructor-Sidebar-Menu-Item_open' : ''}`} key={item.id}>

      <span  className="Constructor-Sidebar-Menu-Item-Title" onClick={() => this.setCategory(null, categoryId)}>
        <div className="Constructor-Sidebar-Menu-Item-Thumb">
          {media && media.thumb ? <img src={media.thumb.xs} alt={name}/> : null}
        </div>
        <div className="Constructor-Sidebar-Menu-Item-Label">{item.name}</div>
      </span>
      {item.items  && this.renderChilds(item.items, item.id, id) }
    </li>;
  };
  renderCatalog = () => {
    return <ul className="Constructor-Sidebar-Menu-Item-List">{this.props.categories && this.props.categories.map((category) => this.renderCategory(category))}</ul>;
  };
  renderScrollBar = () => {
    const {currentCategory, items, isSearch} = this.props;

    return (isSearch || (currentCategory && currentCategory.pid)) && <div className="Constructor-Sidebar-Scroll">
      <Scrollbars  ref="scrollbars"
                   className="Constructor-Sidebar-Scroll-Content"
                   renderTrackVertical={(style, ...props) => {
                     return (
                         <div className="Constructor-Sidebar-Scroll-Scroller" style={style}{...props}/>
                     );
                   }}
                   renderThumbVertical={(style, ...props) => {
                     return (
                         <div style={style}{...props}/>
                     );
                   }}
      >
        <ul>{items && items.map(item => this.renderItemInScroll(item))}</ul>
      </Scrollbars>
    </div>
  };
  renderItemInScroll = (item) => {
    return (
        <li key={`itemInScroll-${item.id}`} onClick={() =>{this.props.addItem(item);}} data-category={item.category}>
          <span className="Constructor-Sidebar-Scroll-Content-Label">{item.name}</span>
          <img className="Constructor-Sidebar-Scroll-Content-Thumb img-fluid" src={item.thumb} alt={item.name}/>
          <span className="Constructor-Sidebar-Scroll-Content-Article">{item.article}</span>
        </li>
    );
  };
  render() {
    return <section className={`${this.props.className}`} ref="AppSidebar">

      <div className="Constructor-Sidebar-Toggle">
        <div className="Constructor-Sidebar-Toggle-Button" onClick={this.props.toggle}>
          <div className="Constructor-Sidebar-Toggle-Button-Icon">
            <FontAwesomeIcon icon={faAngleDoubleLeft}/>
          </div>
        </div>
      </div>

      <div className="Constructor-Sidebar-Menu">

        <div className="Constructor-Sidebar-Menu-SearchForm" >
          <input name="searchText" type="text" placeholder="Поиск по каталогу ..."
                 onChange={this.handleOnChange}
                 onKeyUp={(e) => {
                   if(e.keyCode === 13  || !this.state.searchText.length) {
                     this.props.search(this.state.searchText);
                   }
                 }}
                 value={this.state.searchText}/>
          <input className='SearchForm-lens' type="button" value="8" onClick={() => {
            this.props.search(this.state.searchText);
          }}/>
        </div>
        <hr/>
        {this.renderCatalog()}
      </div>

      {this.renderScrollBar()}

    </section>;
  }
}

MenuLeft.propTypes = {
  toggle: PropTypes.func,
  setCategory: PropTypes.func,
  addItem: PropTypes.func,
  search: PropTypes.func,
  categories: PropTypes.array.isRequired,
  items: PropTypes.array,
  currentCategory: PropTypes.object,
};

export default MenuLeft;
